import React from 'react';
import FormModal from '../../../../../form/FormModal';
import type { GridSettingsPreference, GridSettingsSortField, GridSettingsSortOption } from '../../types';
import { useGridSettingsModal } from '../hooks/useGridSettingsModal';
import { GridSettingsConfirmations } from './internal/GridSettingsConfirmations';
import { GridSettingsForm } from './internal/GridSettingsForm';

type GridSettingsModalProps = {
    open: boolean;
    title: string;
    entityName?: string;
    showSortGroup: boolean;
    showAutosize: boolean;
    sortOptions: GridSettingsSortOption[];
    sortFields: GridSettingsSortField[];
    inGroupSortOptions: GridSettingsSortOption[];
    preference: GridSettingsPreference;
    autosizeEnabled: boolean;
    onClose: () => void;
    onSave: (preference: GridSettingsPreference, autosizeEnabled: boolean) => void;
};

export function GridSettingsModal({
    open,
    title,
    entityName,
    showSortGroup,
    showAutosize,
    sortOptions,
    sortFields,
    inGroupSortOptions,
    preference,
    autosizeEnabled,
    onClose,
    onSave
}: GridSettingsModalProps) {
    const {
        draft,
        confirmAutosizeOpen,
        customRemovalPending,
        pendingSortFieldRemoval,
        handleAutosizeChange,
        handleConfirmAutosize,
        handleCancelAutosize,
        handleSortByChange,
        handleSortFieldsChange,
        handleValueOrderChange,
        handleInGroupSortChange,
        handleGroupedFieldChange,
        handleConfirmCustomRemoval,
        handleCancelCustomRemoval,
        handleConfirmSortFieldRemoval,
        handleCancelSortFieldRemoval,
        handleSave
    } = useGridSettingsModal({
        open,
        sortFields,
        preference,
        autosizeEnabled,
        onSave
    });

    return (
        <>
            <FormModal
                id="data-grid-settings-modal"
                title={title}
                isOpen={open}
                width="560px"
                onClose={onClose}
                onSave={handleSave}
            >
                <GridSettingsForm
                    entityName={entityName}
                    showSortGroup={showSortGroup}
                    showAutosize={showAutosize}
                    sortOptions={sortOptions}
                    sortFields={sortFields}
                    inGroupSortOptions={inGroupSortOptions}
                    draft={draft}
                    customRemovalPending={customRemovalPending}
                    onSortByChange={handleSortByChange}
                    onSortFieldsChange={handleSortFieldsChange}
                    onValueOrderChange={handleValueOrderChange}
                    onInGroupSortChange={handleInGroupSortChange}
                    onGroupedFieldChange={handleGroupedFieldChange}
                    onAutosizeChange={handleAutosizeChange}
                />
            </FormModal>
            <GridSettingsConfirmations
                confirmAutosizeOpen={confirmAutosizeOpen}
                customRemovalPending={customRemovalPending}
                pendingSortFieldRemoval={pendingSortFieldRemoval}
                onConfirmAutosize={handleConfirmAutosize}
                onCancelAutosize={handleCancelAutosize}
                onConfirmCustomRemoval={handleConfirmCustomRemoval}
                onCancelCustomRemoval={handleCancelCustomRemoval}
                onConfirmSortFieldRemoval={handleConfirmSortFieldRemoval}
                onCancelSortFieldRemoval={handleCancelSortFieldRemoval}
            />
        </>
    );
}
